import { render, staticRenderFns } from "./YourOrder.vue?vue&type=template&id=4b6f7791&lang=pug&"
import script from "./YourOrder.vue?vue&type=script&lang=js&"
export * from "./YourOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports